import React, { Component } from "react";
import Footer from "../../components/Footer";
import api from "../../services/api";
import company from "../../config/company";
import Header from "../../components/Header";
import About from "../../components/About";
import axios from "axios";
import Confetti from 'react-confetti';
import Load from "../../components/Load";
import swal from "sweetalert";
import Sector from "../../components/Sector";
import Company from "../../components/Company";
import Social from "../../components/Social";


export default class Home extends Component {

    state = {
        sectors: [],
        sector: [],
        candidate: [],
        confetti: false,
        screenWidth: 0,
        screenHeight: 0,
        loading: false
    }

    componentDidMount() {
        this.getSectors();
        this.setState({
            screenWidth: parseInt(document.documentElement.clientWidth),
            screenHeight: parseInt(document.documentElement.clientHeight)
        });
    }

    getSectors = async () => {
        const response = await api.get(`/api/sector/${company._id}`);
        this.setState({ sectors: response.data });
    }

    handleSector = (sector = {}) => this.setState({ sector });

    myChangeHandler = (event) => {
        let nam = event.target.name;
        let val = event.target.value;
        if (nam === "file") {
            this.setState({
                candidate: {
                    ...this.state.candidate,
                    [nam]: event.target.files[0],
                    fileName: event.target.files[0].name
                }
            });
        }
        else if (nam === "zipcode") {
            this.getAddress(val);
        }
        else {
            this.setState({
                candidate: {
                    ...this.state.candidate,
                    [nam]: val
                }
            });
        }
    }

    getAddress = async (zipcode) => {
        zipcode = String(zipcode).normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '');
        if (zipcode.length >= 8) {
            const response = await axios.get(`https://cors-anywhere.herokuapp.com/https://viacep.com.br/ws/${zipcode}/json/`);
            if (response.data !== null) {
                this.setState({
                    candidate: {
                        ...this.state.candidate,
                        zipcode: zipcode,
                        address: response.data.logradouro,
                        city: response.data.localidade,
                        state: response.data.uf,
                    }
                })
            }
        }
    }

    save = async (event) => {
        this.setState({ loading: true });
        event.preventDefault();
        const { candidate, sector } = this.state;
        const formData = new FormData();
        formData.append('file', candidate.file);
        formData.append('companyId', company._id);
        formData.append('name', candidate.name);
        formData.append('email', candidate.email);
        formData.append('sector', sector.name);
        formData.append('laborBond', candidate.laborBond);
        formData.append('phone', candidate.phone);
        formData.append('dateOfBirth', candidate.dateOfBirth);
        formData.append('address', candidate.address);
        formData.append('city', candidate.city);
        formData.append('state', candidate.state);
        formData.append('zipcode', candidate.zipcode);
        formData.append('linkedin', candidate.linkedin);
        formData.append('facebook', candidate.facebook);
        formData.append('instagram', candidate.instagram);
        formData.append('portfolio', candidate.portfolio);

        await api.post("/api/candidate", formData)
            .then(() => {
                this.setState({ confetti: true, loading: false, sector: [], candidate: [] });
                swal("Sucesso!", "Currículo cadastrado com sucesso!", "success").then(() => {
                    this.setState({ confetti: false });
                });
            })
            .catch(() => {
                this.setState({ loading: false });
                swal("Erro!", "Falha ao cadastrar currículo.", "error");
            });
    }

    render() {
        const { sectors, sector, candidate, confetti, screenWidth, screenHeight, loading } = this.state;

        return (
            <>
                <Header background={company.image.header} logo={company.image.logo} />
                <About background={company.image.about} about={company.about} />
                <Sector sectors={sectors} sector={sector} candidate={candidate} save={this.save} myChangeHandler={this.myChangeHandler} handleSector={(event) => this.handleSector(event)} color={company.color} />
                <Company company={company} />
                <Social company={company} />
                <Footer />
                {(confetti) ?
                    <Confetti style={{ position: "fixed" }} width={screenWidth} height={screenHeight} colors={[company.color.primary, company.color.secondary, "#fff", "#000"]} />
                    : <></>}
                <Load active={loading} />
            </>
        );
    }
}